// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"465":"9fb88ab9","703":"f88c0131","787":"f29fe0a5"}[chunkId] + ".chunk.js";
};